import React, { useEffect, useContext, useState } from "react"
import PropTypes from "prop-types"

// Actions
// import {
//   addProductToCart,
//   resetCartError,
// } from "components/Stacker/actions/CartActions"
import {
  setSizeSelectionError,
  resetSizeSelectionError,
} from "components/Stacker/actions/ProductDetailActions"
import { resetPRC } from "components/Stacker/actions/ProductConfiguratorActions"
import { toggleToggle } from "components/Stacker/actions/ToggleActions"

// Styles
import "./AddToBag.scss"

import { getButtonStyles, getErrorStyles } from "components/DYStackers/styles"

import { StackerContext } from "components/DYStackers/StackerContext"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useI18nContext } from "i18n/i18n-react"

function AddToBag(props) {
  const { LL } = useI18nContext()
  const [isButtonClick, setIsButtonClick] = useState(false)
  const stackerContext = useContext(StackerContext)
  const errorPid = useSelector((state) => state?.cart?.meta?.pid)
  const dispatch = useDispatch()

  // useEffect(() => {
  //   dispatch(resetCartError())
  //   return () => {
  //     const { pid } = props
  //     dispatch(resetSizeSelectionError({ pid }))
  //   }
  // })

  const handleAddToCart = () => {
    const stacker = stackerContext.getInstance()
    const {
      sku,
      pid,
      //isQuickView = false,
      isProductConfigurable,
      //productConfigOptions,
      isStackedProduct = false,
      enagraveableProductConfig,
      //isPreorder,
      //scheduledShipDate,
    } = props

    if (sku) {
      // const params = {
      //   sku,
      //   productConfigOptions,
      //   isQuickView,
      //   isProductConfigurable,
      //   pid,
      //   isStackedProduct,
      //   isPreorder,
      //   scheduledShipDate,
      // }
      // TODO: may want to revisit this for more thorough review
      // dispatch(addProductToCart(params));
      setIsButtonClick(true)
      if (isProductConfigurable) {
        setTimeout(() => {
          dispatch(resetPRC())
        }, 710)
        if (enagraveableProductConfig) {
          dispatch(toggleToggle("enagraveableProductConfig"), false)
        }
      }
    } else {
      dispatch(setSizeSelectionError({ pid, value: true, isStackedProduct }))
    }
    return stacker.onAddToCart({ sku, quantity: 1, pid })
  }

  const { errorMessage, isCartDataLoading, isError, productType } = props
  const { pid } = props

  const error = `${errorMessage}`
  const isButtonDisabled = isCartDataLoading && isButtonClick
  let analyticsId = {}
  if (productType) {
    analyticsId =
      productType === "amulets"
        ? "DY_AmuletBuilderAddToBag_Btn"
        : "DY_BraceletBuilderAddToBag_Btn"
  }

  const showError =
    (isError && errorPid && pid && errorPid === pid) || (isError && !errorPid)

  return (
    <div className="AddToBag">
      <button
        id={analyticsId}
        className="c-btn primary d-flex w-100 align-items-center justify-content-center"
        onClick={handleAddToCart}
        disabled={isButtonDisabled}
        aria-disabled={isButtonDisabled}
        style={getButtonStyles()}
      >
        {!isButtonDisabled && LL.generic.addToCartText()}
        {isButtonDisabled && LL.generic.addingToCartText()}
      </button>
      {showError && (
        <p className="error-text" style={getErrorStyles()}>
          {error}
        </p>
      )}
    </div>
  )
}

AddToBag.propTypes = {
  enagraveableProductConfig: PropTypes.bool,
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isCartDataLoading: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
  isProductConfigurable: PropTypes.bool,
  isPreorder: PropTypes.bool,
  scheduledShipDate: PropTypes.string,
  isQuickView: PropTypes.bool,
  isStackedProduct: PropTypes.bool,
  pid: PropTypes.string.isRequired,
  productConfigOptions: PropTypes.object,
  productType: PropTypes.string,
  sku: PropTypes.string,
}

export default AddToBag
